/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Link, { LinkTheme } from '../../atoms/link/link';
import { getLink } from '../../../routes/route';
import { IconType } from '../../atoms/icon/icon';
import LoadFromCatalogButton from '../loadFromCatalogButton/loadFromCatalogButton';
import { useLocation } from 'react-router-dom';


const FormLoadOtherResource = (props) => {
  const {
    configFile,
    calledId,
    match,
    value,
  } = props;
  const location = useLocation();
  const createPath = `${getLink(configFile.createPath, location.pathname, configFile.actionGetDraftId())}/${calledId}`;
  const editPath = `${getLink(configFile.editURL, location.pathname, value !== undefined && value !== null ? value.id : '')}/${calledId}`;

  return (
    <div>
      { (value === undefined || value === null)
      && [
        <Link
          key={`${configFile.attributeName}-1`}
          theme={LinkTheme.SECONDARY}
          to={createPath}
        >
          New
        </Link>,
        <LoadFromCatalogButton
          aditionalData={{ [configFile.idAttributeName]: calledId }}
          key={`${configFile.attributeName}-2`}
          label={configFile.label}
          configFile={configFile.fromCatalog}
        />,
      ]}
      { (value !== null && value.name !== undefined)
      && [
        <span
          className="mr-2"
          key={`${configFile.attributeName}-1`}
        >
          {value[configFile.displayText]}
        </span>,
        <Link
          key={`${configFile.attributeName}-2`}
          className="mr-2"
          theme={LinkTheme.WARNING}
          to={editPath}
          icon={IconType.EDIT}
        />,
      ]}
    </div>
  );
};

FormLoadOtherResource.propTypes = {
  configFile: PropTypes.shape({}).isRequired,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.bool, PropTypes.shape({})]),
  calledId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

FormLoadOtherResource.defaultProps = {
  value: undefined,
};


export default FormLoadOtherResource;
